import axiosInstance from './api';

export const uploadFile = async (ideaId, file, token) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axiosInstance.post(`/files/${ideaId}/upload`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (err) {
    console.error('File upload error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw new Error(err.response?.data?.detail || 'Failed to upload file');
  }
};

export const getFile = async (filename, token) => {
  try {
    const response = await axiosInstance.get(`/files/${filename}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });
    return response.data;
  } catch (err) {
    console.error('File retrieval error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw new Error(err.response?.data?.detail || 'Failed to retrieve file');
  }
};

export const deleteFile = async (filename, token) => {
  try {
    const response = await axiosInstance.delete(`/files/${filename}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error('File deletion error:', {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
    throw new Error(err.response?.data?.detail || 'Failed to delete file');
  }
};